import React from 'react';
import { useNavigate } from 'react-router-dom';



function TermsOfService() {
    const navigate = useNavigate();
    const handleBack = () => {
        navigate(-1);
      };
  return (
    
     <div style={{ padding: '20px', maxWidth: '800px', margin: '0 auto' }}>
        <button 
    onClick={handleBack} 
    style={{ position: 'absolute',fontFamily: "'montserrat', sans-serif",left: '40px', top: '30px', textDecoration: 'none',  color: 'black', backgroundColor: 'white', border: 'none', cursor: 'pointer',  }}>
    <img src="https://static.thenounproject.com/png/1875804-200.png" style={{width: '30px', opacity: '50%'}}/></button>
      <h1 style={{ textAlign: 'center', fontSize: '24px', marginBottom: '20px' }}>
      4FRNT Terms Of Service 
      </h1>
      <p>
      4FRNT Education LLC., ("4FRNT Education LLC", "we", "us" and "our") is providing these Terms of Service, as updated from time to time, ("Terms") to govern access and usage of our 4FRNT Education LLC software as a service platform ("Service"). These Terms constitute a binding legal agreement between the incorporated entity, 4FRNT Education LLC., and natural or legal persons accessing or using the Service ("you"). In these Terms, "we", "us" and "our" refer to 4FRNT Education LLC., and "you" or "your" refers to users accessing or using the Service for any purpose. From this point forward in the document, "we", "us" or "our" will refer to 4FRNT Education LLC. as the provider of the Service and "you" or "your" will refer to natural or legal persons, and related individuals  users that use or have access to the Service in any context. 

The remainder of these Terms of Service will be written according to definitions of both parties 

as specified here. 

4FRNT Education LLC provides various services, including our website (www.4FRNT.education) and related technologies (collectively referred to as the "Service"). By using any part of the Service, you agree to be bound by these Terms of Service, so please read them carefully. We may need to change these terms occasionally and will post updates in the application and notify you if any changes are significant. Your continued use of the service upon such notification will be deemed as an acknowledgement and agreement with the updated Terms.  </p>
      <h2 style={{ fontSize: '20px', marginTop: '30px' }}> Key Points </h2>
      <p>
      ● This Service is provided by 4FRNT Education LLC and its affiliates ("we"/"us"). <br></br>

● By using the Service you agree to these Terms, which establish a contract between us. <br></br>

● We may modify these terms and will notify you accordingly to your registered e-mail address.  <br></br>

● You can only resolve disputes with us through individual arbitration or small claims court. Class actions are waived. By accepting these Terms, you voluntarily agree to waive your right to be a part of Class Actions.  <br></br>
<br></br>
See below arbitration section for details.  </p>
      <h2 style={{ fontSize: '20px', marginTop: '30px' }}>Arbitration Provision </h2>
      <p>
      Any dispute must be resolved through binding non-appearance-based arbitration on an individual basis. Arbitration replaces the right to go to court, have a jury trial or initiate or participate in a class action. We both agree to give up certain rights to litigate disputes in court. Right to opt out: You have the right to opt out of arbitration within 30 days of first use by emailing 
rodrigo.duran@4FRNT.Education.  </p>
      <h2 style={{ fontSize: '20px', marginTop: '30px' }}>Service Overview </h2>
      <p>4FRNT Education LLC provides an AI-powered platform to enhance teaching and learning. Teachers and students can register to access features to grade, make, and review assessments with Artificial intelligence. </p>
        <h2 style={{ fontSize: '20px', marginTop: '30px' }}>Your Account </h2>
        <p>
      To fully use 4FRNT Education LLC you must register for an account and therefore accept these Terms . By registering, you agree to provide accurate information and keep your account secure. You are responsible for any activity under your account. 
<br></br>
Personal Use License 
<br></br>
4FRNT Education LLC grants you a limited, revocable license to access and use the Service for your own personal, non-commercial purposes, provided you comply with these Terms. 
<br></br>
<br></br>
Restrictions 
<br></br>
<br></br>
You may not: 
<br></br>
<br></br>
● Use the Service for any business, commercial or for-profit purposes <br></br>

● Copy, distribute, sublicense, transfer, modify, or reuse any portion of the Service <br></br>

● Display or perform publicly any content from the Service <br></br>

<br></br>Unless expressly allowed in these Terms or the Service itself, your use of the platform must be solely for your own individual, non-commercial activities. We reserve the right to revoke this license if you violate these restrictions.  
   </p>
      <h2 style={{ fontSize: '20px', marginTop: '30px' }}>School Partnerships </h2>
      <p>
      4FRNT Education LLC may partner with some schools and/or school districts to provide the service to teachers and students. These partnerships require authorization from school administrators or District representatives.    </p>
      <h2 style={{ fontSize: '20px', marginTop: '30px' }}>Individual Educators </h2>
      <p>
      Individual educators (Teachers) may also use 4FRNT Education LLC in their activities, but they  are responsible for obtaining parental consent for student use as needed upon sign up, and accepting these Terms indicates that the Teacher has obtained and kept appropriate records of the student or minor consent, given by their legal guardian. We may provide student account access to legal guardians / parents upon request.  </p>
     
      <h2 style={{ fontSize: '20px', marginTop: '30px' }}> Account Termination </h2>
      <p>
      4FRNT Education LLC may suspend, terminate, or restrict access to your account or the Service at any time without notice. This includes removing content if we believe you violated these Terms. Suspicious illegal activity may be reported to authorities. 

We may also discontinue parts or all of the Service without notice. You agree 4FRNT Education LLC is not liable to you or third parties for terminating access. 

If your account is deactivated, your information and files may be immediately deleted without chance for recovery. You agree we have no obligation to retain data for suspended or closed accounts. 
      </p>
      <h2 style={{ fontSize: '20px', marginTop: '30px' }}>User Disputes  </h2>
      <p>
 

      You are fully responsible for your interactions with other users. 4FRNT Education LLC has no liability related to disputes between users, though we reserve the right to intercede in certain situations. 

 

These Terms constitute the entire agreement governing access to the 4FRNT Education LLC Service. They supersede any prior terms or agreements with respect to the Service. Additional terms may apply when utilizing third-party services, content or software integrated with the Service. 
      </p>
      <h2 style={{ fontSize: '20px', marginTop: '30px' }}> Service Updates </h2>
      <p>
      We may modify or discontinue parts of the service without notice. You agree that we will not be liable for any changes made to the 4FRNT Education LLC platform.  
      </p>
      <h2 style={{ fontSize: '20px', marginTop: '30px' }}>Data Storage & Access   </h2>
      <p>
      We establish limits on data storage and account inactivity which may result in removal or deletion of certain data or accounts for which 4FRNT LLC is not liable. We may change data practices at any time without notice. 
      </p>
      <h2 style={{ fontSize: '20px', marginTop: '30px' }}> Appropriate Use </h2>
      <p>
      You are responsible and liable for any content you provide through the Service. Do not upload or share anything illegal, harmful, or offensive. 
      <br></br><br></br>
Prohibited Activities <br></br><br></br>

You may not use the Service to incur any illegal activity, including but not limited to: 

● Break laws or regulations <br></br>

● Impersonate others <br></br>

● Disrupt our systems and networks <br></br>

● Solicit minors <br></br>

● Collect user data without consent <br></br>

● Sell goods or services not authorized <br></br>

● Promote criminal plans or activities <br></br>

● Access unauthorized content <br></br>

● Circumvent security measures <br></br>

● Scrape or extract data <br></br>

Inappropriate Content <br></br><br></br>

 

Do not upload or distribute: <br></br><br></br>

● Content that violates privacy or security <br></br>

● Unlawful, abusive, violent, vulgar, or hateful content <br></br>

● Content that infringes rights or contains viruses <br></br>

● Spam, junk mail, chain letters, ponzi schemes <br></br>

● Other objectionable or harmful content <br></br>
      </p>
      <h2 style={{ fontSize: '20px', marginTop: '30px' }}>Enforcement  </h2>
      <p>
      We reserve the right to investigate, or not, violations of these rules, which may or may not result in removing content or suspending accounts. We also may report violations to authorities . 
      </p>
      <h2 style={{ fontSize: '20px', marginTop: '30px' }}>User Content & Copyright  </h2>
      <p>
      Any material you provide or upload for use in creating assignments remains your property. By uploading content, you represent that you have the right to use that material and have not infringed any other party's rights. 
      <br></br>
      <br></br>
      4FRNT Education LLC does not claim ownership of any source materials uploaded or submitted by users. You are solely responsible for ensuring you have proper rights or permissions to use all source content.  
      
      <br></br>
      <br></br>
      We are not responsible for third party content. You bear all risks related to accessing third party content. 
      <br></br>
      <br></br>
      You consent to the input and use of all the third-party material in the Create Assignment and Test taking page or any future tool with equivalent or similar functionality, to generate the necessary questions and grade and fully understand that any liabilities or Violation of these terms associated are your responsibility, though we may remove content violating these Terms.  
      <br></br>
      <br></br>
      If we receive any Digital Millennium Copyright Act (“DMCA”) takedown notices related to source materials you have provided, you may be liable for the claims. We reserve the right to remove any allegedly infringing content. 
      <br></br>
      <br></br>
      Users should only upload and use source materials that are free domain, that they have created, or have explicit rights to use . 
      </p>
      <h2 style={{ fontSize: '20px', marginTop: '30px' }}> IP Protection </h2>
      <p>
      To protect 4FRNT Education LLC's intellectual property and proprietary systems, by agreeing to this contract you declare that you are not a current Business Competitor, or that you are using the service for malicious intent, and further declare that you are not a contractor, agent, current  employee, or affiliate of any kind of competitive education technology companies.,  

You may to access the service if you fall in any of the previously described categories, only after obtaining a previous written authorization by us. 

Business Competitor include but are not limited to: 
<br></br>

● Any company offering AI writing assistance, automated feedback tools, plagiarism checking, or other products in the automated teaching space <br></br>

● Direct competitors in the K-12 or higher education technology market <br></br>

● Companies developing competing machine learning algorithms or datase<br></br>

      </p>
      <h2 style={{ fontSize: '20px', marginTop: '30px' }}> Trademarks  </h2>
      <p>
      The 4FRNT Education LLC name, logo, and branding are trademarks owned by 4FRNT Education LLC. Names and logos of other companies displayed in the Service may also be protected trademarks of their respective owners, and nothing indicates endorsement or affiliation unless expressly stated. You may not use 4FRNT Education LLC trademarks without permission. 

      </p>
      <h2 style={{ fontSize: '20px', marginTop: '30px' }}> Indemnity  </h2>
      <p>
      You agree to fully defend, indemnify, and hold 4FRNT Education LLC harmless from any claims, losses or damages relating to or arising out of: <br></br><br></br>

● Your use and access of the Service <br></br><br></br>

● Any content you submit <br></br><br></br>

● Violations of these Terms <br></br><br></br>

● Harm caused to any third party <br></br><br></br>

We reserve the rights to take over managing the defense for any indemnified claims. You may not settle claims against us without written consent. 

      </p>
      <h2 style={{ fontSize: '20px', marginTop: '30px' }}> Disclaimer  </h2>
      <p>
      YOUR USE OF THE SERVICE IS AT YOUR OWN RISK. WE PROVIDE THE PLATFORM "AS IS" WITHOUT WARRANTIES OF ANY KIND.  WE MAKE NO PROMISES THAT THE SERVICE WILL: <br></br>
      ● MEET YOUR REQUIREMENTS <br></br>

● BE AVAILABLE WITHOUT INTERRUPTION OR ERRORS <br></br>

● PROVIDE ACCURATE OR RELIABLE RESULTS <br></br>

● MEET THE QUALITY OF ANY PURCHASED GOODS OR SERVICES <br></br>

YOU ASSUME FULL RESPONSIBILITY AND RISK FOR USING THE PLATFORM. <br></br>
      </p>
      <h2 style={{ fontSize: '20px', marginTop: '30px' }}>  Limitation of Liability </h2>
      <p>
      OUR LIABILITY FOR DAMAGES RELATED TO THE SERVICE IS LIMITED TO THE GREATER OF: <br></br>

(A) THE AMOUNT YOU PAID US IN THE PAST 3 MONTHS, OR <br></br>

(B) $50 <br></br>

WE WILL NOT BE LIABLE FOR ANY: <br></br>

- INDIRECT, INCIDENTAL, PUNITIVE OR CONSEQUENTIAL DAMAGES <br></br>

- DAMAGES FROM LOSS OF PROFIT, DATA, GOODWILL OR OTHER LOSSES <br></br>

- LOSSES RELATED TO GOODS/SERVICES BOUGHT THROUGH THE SERVICE <br></br>

THE ABOVE LIMITATIONS AND EXCLUSIONS MAY NOT APPLY IN SOME JURISDICTIONS. <br></br>

 

IF YOU ARE DISSATISFIED WITH THE SERVICE OR THESE TERMS, YOUR ONLY RECOURSE IS TO STOP USING THE SERVICE. <br></br>

FOR NEW JERSEY USERS, OUR LIABILITY IS LIMITED TO THE GREATEST EXTENT PERMITTED UNDER STATE LAW. <br></br>

Any dispute arising between you and 4FRNT Education LLC must be resolved through binding arbitration before the American Arbitration Association instead of in court. This agreement waives both parties' rights to a jury trial or participation in class actions. Exceptions exist for individuals bringing claims in small claims court, or for bringing issues to the attention of government agencies. Arbitration will proceed on an individual basis only; no consolidation or joining of claims and no group, representative, or class proceedings. We commit to attempting to informally resolve disputes via email before serving a formal Notice of Dispute to initiate arbitration. The arbitration process will follow the AAA's Consumer Arbitration Rules, with this Arbitration Agreement governing whenever its terms conflict with the AAA Rules. We will cover all arbitration costs if forcing you to pay would make arbitration prohibitively expensive. 

Arbitrators can award all the same remedies to individuals as courts, and their decisions are enforceable but may be appealed on limited grounds. Hearings will occur at reasonably convenient locations, factoring in travel limitations. You may reject changes made to this section within 30 days of modifications. If any part is found invalid or unenforceable, the rest of the Terms will remain in force. In summary, this agreement establishes binding individual arbitration as the dispute resolution process fo r most issues between 4FRNT Education LLC and users, waiving court trials and class wide claims in favor of a private arbitrator while still allowing individuals to pursue small claims cases or bring concerns to regulators. 

 

      </p>
      <h2 style={{ fontSize: '20px', marginTop: '30px' }}> Governing Law  </h2>
      <p>
      These Terms are governed by Florida state law without regard to conflict of law principles. With 

respect to non-arbitrated disputes, you and 4FRNT Education LLC consent to the jurisdiction of 

courts located in Miami, Florida <br></br>

Changes & Enforceability <br></br>

We may fail to enforce a provision without waiving the right later. If any term is invalid, the 

parties intend for the court to give effect to intent shown by the term, with other provisions 

remaining in full force. <br></br>

 

You must file claims related to the Service or Terms within 1 year after accrual or they are 

barred. Printed versions carry the same legal authority for proceedings as electronic. 

General Provisions <br></br>

You cannot assign the Terms without consent; 4FRNT Education LLC can freely assign them. 

Section titles do not limit meaning. “Include” and variations imply “without limitation.” Notices 

may be provided by email, mail or through the Service. 

      </p>
      <h2 style={{ fontSize: '20px', marginTop: '30px' }}> Force Majeure  </h2>
      <p>
      4FRNT Education LLC will not be liable for losses caused by Force Majeure events, including but not limited to, performance failures due to civil disturbances, 
<br></br>
natural disasters, terrorist activities or other circumstances reasonably outside control. <br></br>

      </p>
      <h2 style={{ fontSize: '20px', marginTop: '30px' }}>Additionally:   </h2>
      <p>
      - Entire agreement replacing previous terms, but additional rules may govern third-party 

integrations 

- Florida Law governs all non-arbitrated disputes;  <br></br>

- Invalid term provisions severed to retain intent <br></br>

- 1 year limit to file claims <br></br>

- 4FRNT Education LLC can assign agreement <br></br>

- Section titles are convenience only <br></br>

- Notices through email, mail or in product <br></br>

- No liability for unforeseen events outside control  <br></br>

These Terms and related policies are the full agreement for the Service, governed under Florida 

law. Individual sections can be severed if invalid without impairing other terms. Users consent to 

Florida courts and arbitration rules, with a one-year limit to bring claims. Additional 

restrictions may cover third party tools.  <br></br>

Force majeure releases 4FRNT Education LLC from liability for unforeseen events. 

      </p>
 
      <p style={{ marginTop: '30px' }}>
        If you have any questions about these terms and conditions, please rodrigo.duran@4frnt.education.
      </p>
    </div>
  );
}

export default TermsOfService;